export const ActionKeys = Object.freeze({
  INSERT_TRACK_INTO_PLAYLIST: 'INSERT_TRACK_INTO_PLAYLIST',
  GET_AND_ADD_REPLAY_TRACK: 'GET_AND_ADD_REPLAY_TRACK',
} as const);

export { PlaylistKeys } from '../constants';
